import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { InsurerProgressItem } from "src/app/share/constants/quotation-progress";

// Card for an insurer that hasn't returned a price yet
@Component({
  selector: "app-waiting-insurer-card",
  templateUrl: "./waiting-insurer-card.component.html",
  styleUrls: ["./waiting-insurer-card.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaitingInsurerCardComponent {
  @Input() item: InsurerProgressItem;
}
